// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2f59n","head":"Table_head__1Aruf","col":"Table_col__ulkcc"};